var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.url
    ? _c(
        "span",
        {
          on: {
            click: function(e) {
              return _vm.handleClick(e)
            }
          }
        },
        [_vm._t("default")],
        2
      )
    : _vm.isInternal
    ? _c("router-link", {
        class: _vm.bemBlock,
        attrs: { to: _vm.relativeUrl },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function(ref) {
                var href = ref.href
                var navigate = ref.navigate
                var isActive = ref.isActive
                var isExactActive = ref.isExactActive
                return [
                  _c(
                    "a",
                    {
                      class: {
                        "router-link-active": isActive,
                        "router-link-exact-active": isExactActive
                      },
                      attrs: { href: href },
                      on: {
                        click: function(e) {
                          return _vm.handleClick(e, navigate)
                        }
                      }
                    },
                    [_vm._t("default")],
                    2
                  )
                ]
              }
            }
          ],
          null,
          true
        )
      })
    : _c(
        "a",
        {
          class: _vm.bemBlock,
          attrs: { target: "_blank", href: _vm.url },
          on: {
            click: function(e) {
              return _vm.handleClick(e)
            }
          }
        },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }